import { useTranslation } from "~/hooks/useTranslation";
import { ENameSpace } from "~/i18n/@types/types";

export const Description = () => {
  const { t } = useTranslation([ENameSpace.Login] as const);

  return (
    <div className="space-y-2 text-center text-ciety-wh">
      <h1 className="typo-book-40">{t(`${ENameSpace.Login}:Root.Title`)}</h1>
      <p className="typo-book-20 pb-1">
        {t(`${ENameSpace.Login}:Root.Description`)}
      </p>
    </div>
  );
};
